export default __webpack_public_path__ + "static/takeoff-081071ac91583c72fc038a1fa6d12b5c.jpg";